import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { AbstractGuard } from '../shared';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services';
import { Observable, of } from 'rxjs';
import { switchMap, map, share } from 'rxjs/operators';
import * as _firebase from 'firebase/app';
const firebase = _firebase;

@Injectable({
  providedIn: 'root'
})
export class TableGuard implements CanActivate {
  constructor (
    private auth:AuthService,
    private abstractGaurd:AbstractGuard,
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const survey_id = next.params.survey_id || next.queryParams.survey_id;
    const checkin = this.abstractGaurd.canActivate(next, state).pipe(
      switchMap(bool=>{
        if (!bool || !this.checkAgainstScope()) {
          return this.auth.upgradeToken(survey_id).pipe(map(()=>this.checkAgainstScope()));
        } else {
          return of(bool);
        } 
      }),
      share(),
    );
    return checkin;
  }
  checkAgainstScope() {
    const idTokenResult = this.auth._idTokenResult;
    return typeof get(idTokenResult, 'claims.replies') !== 'undefined' ? true : false;
  }
}